<template>
  <div class="error-container">
    <div class="error-image">
      <img src="../assets/icons/warning.svg" alt="warning"/>
    </div>
    <div class="error-title">
      <h3>{{ $t("UnexpectedError-title") }}</h3>
    </div>
    <div class="error-subtitle">
      <span class="message">
        {{ $t("UnexpectedError--generic-message") }}
      </span>
    </div>
  </div>
</template>
<script lang="ts">
import {useI18n} from "vue-i18n";
import {computed, defineComponent} from "vue";
import {AnalyticEventsNames,} from "@/helpers/google-analytics.helpers";
import {useStore} from "vuex";
import authHelper from "@/helpers/authHelper";
import {ActionLogTypeConst} from "@/types/IActionLogs";

export default defineComponent({
  props: {
    countryProp: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const {t} = useI18n();
    const store = useStore();
    const country = computed(
      () => store.state.payOptions.deviceInfo.country ? store.state.payOptions.deviceInfo.country : props.countryProp
    );
    const deviceTag = computed(
        () => store.state.payOptions.deviceInfo.deviceTag
    );
    return {
      t,
      store,
      country,
      deviceTag,
    };
  },
  mounted() {
    if (process.env.VUE_APP_USE_ACTION_LOGS === "true") {
      // Log the event on page view
      authHelper.logAction({
        deviceTag: this.deviceTag,
        country: this.country,
        action: AnalyticEventsNames.OnFullyPaidPage,
        actionType: ActionLogTypeConst.PAGE_VIEW
      }, this.$gtag)
    }
  },
  beforeUnmount() {
    if (process.env.VUE_APP_USE_ACTION_LOGS === "true") {
      // Log the event on page unmount
      authHelper.logAction({
        deviceTag: this.deviceTag,
        country: this.country,
        action: AnalyticEventsNames.OnFullyPaidPage_BrowserClose,
        actionType: ActionLogTypeConst.PAGE_VIEW
      }, this.$gtag)
    }
  },
});
</script>
<style scoped>
.error-container {
    display: flex;
    flex-flow: column;
    align-items: center;
    height: auto;
    width: auto;
    padding-top: 35vh;
}
</style>
